<template>
  <div class="register-page">
    <!-- 导航栏 -->
    <HeaderComponent />
    
    <div class="register-container">
      <div class="register-content">
        <div class="register-box">
          <div class="register-header">
            <i class="fas fa-user-plus"></i>
            <h2>弋沐注册</h2>
          </div>
          <form class="register-form" @submit.prevent="handleRegister">
            <div class="form-group">
              <label for="username">用户名</label>
              <input 
                type="text" 
                id="username" 
                v-model="form.username" 
                placeholder="请输入用户名（6-20位字符）"
                required
                autocomplete="off"
              >
              <div class="error-message" v-if="errors.username">{{ errors.username }}</div>
            </div>
            <div class="form-group">
              <label for="password">密码</label>
              <input 
                type="password" 
                id="password" 
                v-model="form.password" 
                placeholder="请输入密码（8-20位字符，包含字母和数字）"
                required
              >
              <div class="error-message" v-if="errors.password">{{ errors.password }}</div>
            </div>
            <div class="form-group">
              <label for="confirmPassword">确认密码</label>
              <input 
                type="password" 
                id="confirmPassword" 
                v-model="form.confirmPassword" 
                placeholder="请再次输入密码"
                required
              >
              <div class="error-message" v-if="errors.confirmPassword">{{ errors.confirmPassword }}</div>
            </div>
            <div class="form-group">
              <label for="captcha">图形验证</label>
              <div class="captcha-container">
                <input 
                  type="text" 
                  id="captcha" 
                  v-model="form.captcha" 
                  placeholder="请输入图形验证码"
                  required
                  maxlength="6"
                >
                <div class="captcha-image" ref="captchaImage" @click="generateCaptcha"></div>
              </div>
              <div class="error-message" v-if="errors.captcha">{{ errors.captcha }}</div>
            </div>
            <div class="form-agreement">
              <input type="checkbox" id="agreement" v-model="form.agreement" required>
              <label for="agreement">我已阅读并同意<a href="#" class="agreement-link">《用户协议》</a>和<a href="#" class="agreement-link">《隐私政策》</a></label>
            </div>
            <button type="submit" class="btn btn-primary btn-block">注册</button>
          </form>
          <div class="register-footer">
            <span>已有账号？</span>
            <router-link to="/login" class="login-link">立即登录</router-link>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 页脚 -->
    <FooterComponent />
  </div>
</template>

<script>
import HeaderComponent from '../components/Header.vue'
import FooterComponent from '../components/Footer.vue'

export default {
  name: 'RegisterView',
  components: {
    HeaderComponent,
    FooterComponent
  },
  data() {
    return {
      form: {
        username: '',
        password: '',
        confirmPassword: '',
        captcha: '',
        agreement: false
      },
      captchaText: '',
      errors: {}
    }
  },
  mounted() {
    this.generateCaptcha()
  },
  methods: {
    generateCaptcha() {
      const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
      this.captchaText = ''
      for (let i = 0; i < 6; i++) {
        this.captchaText += chars.charAt(Math.floor(Math.random() * chars.length))
      }
      this.drawCaptcha()
    },
    drawCaptcha() {
      const canvas = document.createElement('canvas')
      canvas.width = 120
      canvas.height = 40
      const ctx = canvas.getContext('2d')
      
      // 绘制背景
      ctx.fillStyle = '#f5f5f5'
      ctx.fillRect(0, 0, canvas.width, canvas.height)
      
      // 添加干扰线
      for (let i = 0; i < 5; i++) {
        ctx.strokeStyle = this.getRandomColor()
        ctx.lineWidth = Math.random() * 2 + 1
        ctx.beginPath()
        ctx.moveTo(Math.random() * canvas.width, Math.random() * canvas.height)
        ctx.lineTo(Math.random() * canvas.width, Math.random() * canvas.height)
        ctx.stroke()
      }
      
      // 添加干扰点
      for (let i = 0; i < 30; i++) {
        ctx.fillStyle = this.getRandomColor()
        ctx.beginPath()
        ctx.arc(Math.random() * canvas.width, Math.random() * canvas.height, Math.random() * 2, 0, Math.PI * 2)
        ctx.fill()
      }
      
      // 绘制验证码文本
      ctx.font = 'bold 24px Arial'
      ctx.textAlign = 'center'
      ctx.textBaseline = 'middle'
      
      for (let i = 0; i < this.captchaText.length; i++) {
        ctx.fillStyle = this.getRandomColor()
        ctx.save()
        ctx.translate(20 + i * 20, canvas.height / 2)
        ctx.rotate((Math.random() - 0.5) * 0.4)
        ctx.fillText(this.captchaText.charAt(i), 0, 0)
        ctx.restore()
      }
      
      // 更新验证码图片
      const captchaImage = this.$refs.captchaImage
      captchaImage.innerHTML = ''
      captchaImage.appendChild(canvas)
    },
    getRandomColor() {
      const colors = ['#333', '#666', '#999', '#3498db', '#2ecc71', '#e74c3c', '#f39c12']
      return colors[Math.floor(Math.random() * colors.length)]
    },
    validateForm() {
      this.errors = {}
      let isValid = true
      
      // 验证用户名
      if (!this.form.username.match(/^[a-zA-Z0-9_-]{6,20}$/)) {
        this.errors.username = '用户名必须为6-20位字母、数字、下划线或连字符'
        isValid = false
      }
      
      // 验证密码
      if (!this.form.password.match(/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,20}$/)) {
        this.errors.password = '密码必须为8-20位字符，包含字母和数字'
        isValid = false
      }
      
      // 验证确认密码
      if (this.form.password !== this.form.confirmPassword) {
        this.errors.confirmPassword = '两次输入的密码不一致'
        isValid = false
      }
      
      // 验证验证码
      if (this.form.captcha.toLowerCase() !== this.captchaText.toLowerCase()) {
        this.errors.captcha = '验证码错误'
        isValid = false
      }
      
      return isValid
    },
    handleRegister() {
      if (this.validateForm()) {
        // 注册逻辑
        console.log('注册表单:', this.form)
        // 这里可以添加注册API调用
        alert('注册成功！')
        this.$router.push('/login')
      }
    }
  }
}
</script>

<style scoped>
.register-page {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.register-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
  box-sizing: border-box;
}

.register-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding-top: 100px;
}

.register-box {
  margin: 40px auto 40px;
  background: white;
  border-radius: 10px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  padding: 40px;
  width: 100%;
  max-width: 480px;
}

.register-header {
  text-align: center;
  margin-bottom: 30px;
}

.register-header i {
  font-size: 48px;
  color: #667eea;
  margin-bottom: 15px;
}

.register-header h2 {
  color: #333;
  font-size: 24px;
  font-weight: 600;
}

.register-form {
  margin-bottom: 20px;
}

.form-group {
  margin-bottom: 20px;
  position: relative;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  color: #555;
  font-weight: 500;
}

.form-group input {
  width: 100%;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 16px;
  transition: border-color 0.3s;
}

.form-group input:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.2);
}

.error-message {
  color: #e74c3c;
  font-size: 12px;
  margin-top: 5px;
}

.captcha-container {
  display: flex;
  gap: 10px;
  align-items: center;
}

.captcha-container input {
  flex: 1;
}

.captcha-image {
  width: 120px;
  height: 40px;
  cursor: pointer;
  border: 1px solid #ddd;
  border-radius: 5px;
  overflow: hidden;
  background-color: #f5f5f5;
}

.captcha-image canvas {
  width: 100%;
  height: 100%;
}

.form-agreement {
  margin-bottom: 20px;
  font-size: 14px;
  color: #666;
  line-height: 1.5;
}

.form-agreement input {
  margin-right: 8px;
  vertical-align: middle;
}

.agreement-link {
  color: #667eea;
  text-decoration: none;
}

.agreement-link:hover {
  text-decoration: underline;
}

.btn {
  padding: 12px 20px;
  border: none;
  border-radius: 5px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s;
}

.btn-primary {
  background-color: #667eea;
  color: white;
}

.btn-primary:hover {
  background-color: #5568d3;
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(102, 126, 234, 0.3);
}

.btn-block {
  width: 100%;
}

.register-footer {
  text-align: center;
  font-size: 14px;
  color: #666;
}

.login-link {
  color: #667eea;
  text-decoration: none;
  margin-left: 5px;
  font-weight: 500;
}

.login-link:hover {
  text-decoration: underline;
}
</style>